import React, { useState } from "react";
import './Client.css';

const Clients = () => {
  const [modalContent, setModalContent] = useState({ image: "", text: "", link: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (imgSrc, text, link) => {
    setModalContent({ image: imgSrc, text: text, link: link });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const clientsData = [
    {
      title: "TVS Rubber",
      img: "/images/TVS-LOGO.jpg",
      link: "https://tvsrubber.com/",
      desc: `TVS Rubber, a flagship brand of Sundaram Industries Private Limited, has been a pioneer in high-quality automotive rubber components for over 50 years. Renowned for their commitment to precision and durability, TVS Rubber serves global automotive markets with innovative rubber solutions.`
    },
    {
      title: "Sundaram Brake Linings",
      img: "/images/TVS-sundaram.jpg",
      link: "#",
      desc: `Sundaram Brake Linings (SBL) is a globally recognized leader in high-performance friction materials. With decades of expertise, SBL manufactures advanced brake linings and pads designed for optimal safety and efficiency in commercial vehicles worldwide.`
    },
    {
      title: "TVS Eurogrip",
      img: "/images/TVS-eurogrip.jpg",
      link: "https://tvseurogrip.com/?srsltid=AfmBOoosRZ2Wkdqc3gGEGxDZ6f5UAp5bXotzEk5sJWCeI0h-xciEPlUu",
      desc: `TVS Eurogrip is a global powerhouse in two-wheeler and three-wheeler tire manufacturing. With an unwavering focus on research and innovation, they deliver durable, high-performance tires engineered for diverse road conditions and superior riding comfort.`
    },
    {
      title: "Pricol Limited",
      img: "/images/pricol.png",
      link: "#",
      desc: `Founded in 1975, Pricol has evolved into a leading name in automotive technology. With a strong legacy of innovation and excellence, Pricol continues to develop world-class automotive instruments, redefining industry standards with cutting-edge solutions.`
    },
    {
      title: "Motherson Automotive Technologies and Engineering (MATE)",
      img: "/images/motherson.png",
      link: "https://www.motherson.com/company/business-divisions/modules-and-polymer-products",
      desc: `MATE, a division of Motherson Group, is a global leader in polymer solutions and automotive technologies, delivering innovative systems and modules to enhance vehicle performance and safety.`
    },
    {
      title: "SI Air Springs",
      img: "/images/airsprings.png",
      link: "https://www.tvsairsprings.com/",
      desc: `SI Air Springs specializes in air suspension systems, providing durable and high-performance solutions for commercial vehicles, ensuring comfort, stability, and long-term reliability.`
    },
    {
      title: "Sundram Fasteners Ltd.",
      img: "/images/sundaram.png",
      link: "https://www.sundram.com/",
      desc: `Sundram Fasteners Ltd. manufactures high-precision automotive components and industrial fasteners. It is widely recognized for its commitment to quality and engineering excellence.`
    },
    {
      title: "TVS Argomm Private Ltd.",
      img: "/images/argom.png",
      link: "https://www.tvsargomm.com/",
      desc: `TVS Argomm is a premier manufacturer of rubber and plastic components, offering innovative sealing solutions for the automotive sector.`
    },
    {
      title: "Meccanotecnica Umbra",
      img: "/images/umbra.png",
      link: "https://www.meccanotecnica.in/",
      desc: `Meccanotecnica Umbra India designs and produces mechanical seals for various industrial sectors, with a focus on innovation and sustainability.`
    }
  ];

  return (
    <div className="clients-section">
      <h1 className="heading">Our Esteemed Clients</h1>
      <p className="subheading">
        We take pride in collaborating with industry leaders, delivering cutting-edge solutions that drive excellence.
      </p>

      <div className="container">
        {clientsData.map((client, index) => (
          <div
            className="card"
            key={index}
            style={{ animationDelay: `${index * 0.2}s` }}
            onClick={() => openModal(client.img, client.desc, client.link)}
          >
            <img src={client.img} alt={client.title} />
            <p className="card-title">{client.title}</p>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal show-modal">
          <div className="modal-content">
            <span className="close-btn" onClick={closeModal}>×</span>
            <img className="modal-img" src={modalContent.image} alt="Client" />
            <p className="modal-text">{modalContent.text}</p>
            {modalContent.link && (
              <a href={modalContent.link} target="_blank" rel="noopener noreferrer" className="visit-link">
                Visit Website
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Clients;
